// extracted by mini-css-extract-plugin
export default {"root":"barra-progresso_root__LA3ug","label":"barra-progresso_label__p9LhX"};